import { lessonCountPerMonthSchema, paymentTypeSchema } from '@server/schemas'
import { useTranslation } from '@shared/config/i18n'
import { z } from 'zod'

import { ChipV2, HStack } from '@podo-app/design-system-temp'

type Props = {
  selectedLessonCount: NumberEnumToStringEnum<z.infer<typeof lessonCountPerMonthSchema>>
  handleChangeLessonCount: (lessonCount: NumberEnumToStringEnum<z.infer<typeof lessonCountPerMonthSchema>>) => void
  paymentType: z.infer<typeof paymentTypeSchema>
}

const SubscribeTicketLessonCountChip = ({ selectedLessonCount, handleChangeLessonCount, paymentType }: Props) => {
  const t = useTranslation()

  return (
    <HStack className="gap-2">
      {paymentType === paymentTypeSchema.enum.BUSINESS && (
        <ChipV2
          className="flex-1"
          selected={selectedLessonCount === '12'}
          onClick={() => handleChangeLessonCount('12')}
        >
          {t('subscribeList.chip.lessonCountPerMonth', { count: 12 })}
        </ChipV2>
      )}
      <ChipV2
        className="flex-1"
        selected={selectedLessonCount === '999'}
        onClick={() => handleChangeLessonCount('999')}
      >
        {t('subscribeList.chip.unlimited')}
      </ChipV2>
      {paymentType === paymentTypeSchema.enum.SUBSCRIBE && (
        <ChipV2 className="flex-1" selected={selectedLessonCount === '8'} onClick={() => handleChangeLessonCount('8')}>
          {t('subscribeList.chip.lessonCountPerMonth', { count: 8 })}
        </ChipV2>
      )}
    </HStack>
  )
}

export default SubscribeTicketLessonCountChip
